import React from "react"

import SiteLogo from "./siteLogo"
import Menu from "./menu"
import HEADER from '../styles/components/header.module.scss'


const Header = (props) => {
    
    return (
        
        <header className={HEADER.HEADER} >
            <SiteLogo/>
            <nav>
                <Menu nodes={props.menu}/>
            </nav>
        </header>
    )
} 

export default Header